// src/pages/survey/Survey.jsx
import React, { useState } from "react";
import { useAtom } from "jotai";

import SurveyComponent from "./SurveyForm";
import FootpringSvg from "../../assets/Footprints-Logo.svg";
import { activeChildDetail, survey_id } from "../../atomstore/store";
import { useRequestProcessor } from "../../requestProcessor";
import { submitSurvey } from "../../queryfunctions/queryfunctions";
import SpinnerLoading from "./SpinnerLoading";

const Survey = () => {
    const { useMutationWrapper } = useRequestProcessor();
    const [surveyId] = useAtom(survey_id)
    const [activeChild] = useAtom(activeChildDetail)

    console.log("surveyid", surveyId);
    const [state, setState] = useState({
        surveyId: surveyId,
        rating: undefined,
        tags: undefined,
        comment: undefined,
        error: undefined,
    });

    const updateFeedback = useMutationWrapper("raiseIssue", () =>
        submitSurvey(state)
    );

    const validate = () => {
        if (state.rating === undefined) {
            setState({ ...state, error: "Please Select Rating" });
            return false;
        }
        if (!state.tags || state.tags.length === 0) {
            setState({ ...state, error: "Please check the Tags" });
            return false;
        }
        if (!state.comment || state.comment.trim() === "") {
            setState({ ...state, error: "Please Enter Comment" });
            return false;
        }
        return true;
    };

    const submit = () => {
        if (validate()) {
            if (state?.surveyId) {
                updateFeedback.mutate();
            } else {
                setState({ ...state, error: "Survey id missing" });
            }
        }
    };

    return (
        <div
            className="h-dvh bg-cover bg-center overflow-auto"
        // style={{
        //     backgroundImage: `url(${require("../../assets/bg-pattern.jpg")})`,
        // }}
        >

            {updateFeedback?.isLoading && <SpinnerLoading />}
            {/* NAVBAR */}
            <div className="fixed top-0 left-0 w-full bg-white shadow z-20 py-4 flex justify-center overflow-auto">
                <img src={FootpringSvg} alt="Logo" className="h-10" />
            </div>

            {/* TAILWIND MODAL */}
            <div className="fixed inset-0 flex items-center justify-center z-30 px-4 overflow-auto">
                <div className="fixed inset-0 bg-black bg-opacity-40"></div>

                <div className="bg-white rounded-xl w-full max-w-3xl shadow-xl relative z-40  overflow-y-auto">
                    {/* HEADER */}
                    <div className="bg-cyan-600 text-white px-6 py-4 text-lg font-bold">
                        Survey
                    </div>

                    {/* BODY */}
                    <div className="px-6 py-6 space-y-4">
                        <SurveyComponent
                            key={surveyId}
                            onRatingPressed={(rating) =>
                                setState({ ...state, rating, error: undefined })
                            }
                            getComment={(comment) =>
                                setState({ ...state, comment, error: undefined })
                            }
                            getTags={(tags) =>
                                setState({ ...state, tags, error: undefined })
                            }
                            selectedChild={activeChild}
                        />

                        {/* ERROR MESSAGE */}
                        {state.error && (
                            <p className="text-red-500 text-sm font-medium">{state.error}</p>
                        )}

                        {/* SUBMIT BUTTON */}
                        <button
                            className="w-full bg-cyan-600 text-white text-lg py-4 rounded-xl font-semibold shadow hover:bg-cyan-700 transition"
                            onClick={submit}
                        >
                            Submit Feedback
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Survey;
